
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.857 6.286H5.143V20a2.292 2.292 0 002.286 2.286h9.142A2.292 2.292 0 0018.857 20V6.286zm-2.286 2.285V20H7.429V8.571h9.142zm-1.714-6.857H9.143L8 2.857H4v2.286h16V2.857h-4l-1.143-1.143z","fill-rule":"nonzero"}})])
          )
        }
      }
    